declare const __APP_BUILD_VERSION__: string;

/** Current request-compatibility protocol implemented by this add-in build. */
export const CLIENT_PROTOCOL_VERSION = 1;

/**
 * Returns the deployment identity embedded in the add-in bundle.
 *
 * @returns The image/build SHA supplied at build time, or `development` locally.
 * @throws Never.
 */
export function getClientBuildVersion(): string {
  return __APP_BUILD_VERSION__ || "development";
}
